import goals from "../../../../src/components/content/goals/m1";
import * as React from 'react';
export default {
  goals,
  React
};